import script from "./Toggle.vue?vue&type=script&setup=true&lang=js"
export * from "./Toggle.vue?vue&type=script&setup=true&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=5e6b5e33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6b5e33"]])

export default __exports__